import React from 'react'

import FormManager from "../../../../../gd-form/common/form-manager"
import Input from '../../../../../gd-form/form-element/input/input'
import FormError from "../../../../../gd-form/common/form-error/form-error"

type Props = {
    form: FormManager
}

export default function ProjectForm_Name(props: Props) {
    return (
        <div className="row">
            <div className="label">Name</div>
            <div className="element">
                <Input size = "big"
                       form = {props.form}
                       name = "name"/>

                <FormError form = {props.form}
                           name = "name"/>
            </div>
        </div>
    )
}
